import gql from 'graphql-tag';

const channelModuleSettingsFragment = gql`
  fragment ChannelModuleSettings on ChannelSettings {
    hasPerksEnabled
    hasBillingPaymentsEnabled
    hasWorkOrdersEnabled
    hasWorkOrderServiceRequestsEnabled
    hasWorkOrderPreventiveMaintenanceEnabled
    hasWorkOrderEquipmentEnabled
    hasWorkOrderCrossPropertyEnabled
    hasVisitorManagementEnabled
    hasHardwareManagementEnabled
    hasHardwarePinManagementEnabled
    hasReservableManagementEnabled
    hasSurveysEnabled
    hasAccessControlEnabled
    hasSmartUserManagementEnabled
    hasMessagingAndMarketplaceEnabled
    hasInspectionsEnabled
    multiLanguageEnabled
  }
`;

export const channelsByModuleCategoriesQuery = gql`
  ${channelModuleSettingsFragment}
  query channelsByModuleCategories(
    $moduleCategories: [ModuleCategoryEnum!]!
    $pagination: PaginationInput!
  ) {
    me {
      channelsByModuleCategories(
        moduleCategories: $moduleCategories
        pagination: $pagination
      ) {
        channels {
          _id
          name
          type
          profile {
            image
            logo
          }
          address {
            street1
            city
            state
            code
          }
          settings {
            ...ChannelModuleSettings
          }
        }
        pageInfo {
          start
          total
          perPage
        }
      }
    }
  }
`;
